
<section class="content">
  <edit-giftcodes v-if="client.data.id && client.data.id.length > 0" :client="client"></edit-giftcodes>
</section>
